import axios from 'axios';
import { toast } from 'react-toastify';

let isLoggingOut = false;
let isInterceptorSetup = false;

const setupAxiosInterceptor = () => {
  if (isInterceptorSetup) return;

  isInterceptorSetup = true;

  axios.interceptors.response.use(
    (response) => response,

    (error) => {
      const status = error?.response?.status;
      const config = error?.config;
      const url = config?.url?.toLowerCase() || '';

      const token = sessionStorage.getItem('token');

      const ignoredApis = [
        // 'login',
        // 'logout',
        // 'register',
        // 'forgot-password',
        // 'reset-password',
        // 'refresh-token',
        // 'verify',
      ];

      const isIgnoredApi = ignoredApis.some((api) =>
        url.includes(api)
      );

      const hasAuthorization =
        !!config?.headers?.Authorization ||
        !!config?.headers?.authorization;

      if (
        status === 401 &&
        !!token &&
        hasAuthorization &&
        !isIgnoredApi &&
        !isLoggingOut
      ) {
        isLoggingOut = true;

        sessionStorage.clear();

        toast.error('Session expired. Please login again.');

        setTimeout(() => {
          window.location.replace('/business');
        }, 1500);
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptor;